import { IfcObjectPlacement } from "./index.js";
import { IfcVirtualGridIntersection } from "./index.js";
import { IfcDirection } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcgridplacement.htm */
export class IfcGridPlacement extends IfcObjectPlacement {
    get type() {
        return EntityTypesIfc.IFCGRIDPLACEMENT;
    }
    get PlacementLocation() {
        if (this.PlacementLocation_ === void 0) {
            this.PlacementLocation_ = this.extractElement(0, false, IfcVirtualGridIntersection);
        }
        return this.PlacementLocation_;
    }
    get PlacementRefDirection() {
        if (this.PlacementRefDirection_ === void 0) {
            const value = this.extractReference(1, true);
            if (!(value instanceof IfcDirection) && !(value instanceof IfcVirtualGridIntersection) && value !== null) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.PlacementRefDirection_ = value;
        }
        return this.PlacementRefDirection_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcGridPlacement.query = [EntityTypesIfc.IFCGRIDPLACEMENT];
IfcGridPlacement.expectedType = EntityTypesIfc.IFCGRIDPLACEMENT;
